import { GetCompanyLinkType } from 'src/api/generated/touring/types';
import { mapAddress, mapContact } from '../common';
import { CompanyLinkType } from '../mapPersonType/types';
import { mapContactCardType } from './helpers';

export const mapCompanyLinkType = (
  company: GetCompanyLinkType[]
): CompanyLinkType[] => {
  return company.map((item) => ({
    personId: item.personId,
    firstname: item.firstname,
    lastname: item.lastname,
    linkId: item.id,
    type: item.type,
    isDefaultContact: item.isDefaultContact,
    siteId: item.siteId,
    companyName: item.companyName,
    companyId: item.companyId,
    jobTitle: item.jobTitle,
    contact: mapContact(item.contact),
    address: mapAddress(item.address),
    buyerId: item.buyerId,
    excludeFromConfirmationMails: item.excludeFromConfirmationMails,
    hasArtistConnections: item.hasArtistConnections,
    categories: item.categories,
    contactCard: mapContactCardType(item.contactCard),
    canManageContactCard: item.canManageContactCard,
  }));
};
